var map = {
	"./EnrichmentPrograms1.jpeg": 8397,
	"./EnrichmentPrograms2.jpeg": 732,
	"./EnrichmentPrograms3.jpeg": 7667,
	"./EnrichmentPrograms4.jpeg": 1666,
	"./EnrichmentPrograms5.jpeg": 8345,
	"./WhatsApp Image 2026-03-17 at 1.21.08 PM.jpeg": 7644,
	"./WhatsApp Image 2026-03-17 at 1.21.12 PM.jpeg": 9233,
	"./WhatsApp Image 2026-03-17 at 1.21.14 PM.jpeg": 7919,
	"./WhatsApp Image 2026-03-17 at 1.21.18 PM.jpeg": 7139,
	"./WhatsApp Image 2026-03-17 at 1.21.21 PM.jpeg": 6355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6082;